import { create } from 'zustand';
export const useRouteTokenSwitchStore = create((set) => ({
    showTokens: false,
    setShowTokens: (val) => set({ showTokens: val }),
}));
